import { getAzureFilePath } from "../helpers/functions/azure";

export class ModelImage {
  constructor(props = {}) {
    this.path = props.path ? getAzureFilePath(props.path) : ''
    this.pathRef = props.path;
    this.file = props.file;
  }
}